exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pell {\n  border: 1px solid rgba(10, 10, 10, 0.1);\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box; }\n\n.pell-content {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 300px;\n  outline: 0;\n  overflow-y: auto;\n  padding: 10px; }\n\n.pell-actionbar {\n  background-color: #FFF;\n  border-bottom: 1px solid rgba(10, 10, 10, 0.1); }\n\n.pell-button {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  height: 30px;\n  outline: 0;\n  width: 30px;\n  vertical-align: bottom; }\n\n.pell-button-selected {\n  background-color: #F0F0F0; }\n", ""]);

// exports
